import { CheckCircleOutline, EmailOutlined, TextFields } from "@material-ui/icons";
import { Switch, Typography, Button, Box, Modal, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, Select, MenuItem } from "@mui/material";
import QuestionViewModal from "modules/question-bank/questionViewmodal";
import React, { useCallback, useEffect, useState, useRef, useMemo } from "react";
import { apiPaths, getData, postData } from "../platform-components/api-integration-util";
import Grid from "../platform-components/grid/Grid";
import { getUserDetails } from "../platform-components/utils/shared-data.service";
import CloseIcon from '@mui/icons-material/Close';
import JoditEditor from 'jodit-react';
import { Margin } from "@mui/icons-material";
import { Toaster } from '../platform-components/Toaster';
import { toast } from 'react-toastify';
import { checkPermission } from "../platform-components/utils/configuration";
import { filterBySubjectScope } from "../platform-components/utils/subject-scope";
import { formatDateTime } from "../platform-components/utils/common-utils";

const style = {
  display: 'flex',
  flexDirection: 'column',
  m: '0px !important',
  width: 'fit-content'
};
const style1 = {
  display: 'flex',
  flexDirection: 'column',
  //width: 'fit-content',
  width: "100%",
  Margin: "0px !important"
};

const icon = {
  position: "absolute",
  top: " 6px",
  right: "11px",
  fontSize: "16px",
  cursor: "pointer"
}
// ag-grid v22 reads `pagination` / `suppressPaginationPanel` once at grid construction and never
// re-reads them, so the pager cannot be toggled on a live grid. Pagination therefore stays
// permanently on and the pager bar is hidden with CSS when everything fits on one page.
//
// `paginationPageSize` cannot be driven by the prop either: ag-grid's React wrapper copies each
// changed NUMBER_PROPERTY into gridOptions and only then calls api.paginationSetPageSize(), so
// GridOptionsWrapper.setProperty() sees previousValue === value, dispatches no property event and
// the grid silently keeps its original page size. The grid is therefore always constructed with
// DEFAULT_PAGE_SIZE and every later change is pushed through the grid api instead.
const DEFAULT_PAGE_SIZE = 25;
const ALL_PAGE_SIZE = -1;
const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
const SMALLEST_PAGE_SIZE = Math.min(...PAGE_SIZE_OPTIONS);

// ag-grid v22 needs an explicit colDef.sortable; without it header clicks are inert. Hoisted so
// the object identity is stable across renders.
const DEFAULT_COL_DEF = { sortable: true, resizable: true };

const button = {
  marginTop: "10px",
  maxWidth: "120px",
  position: "absolute",
  right: "30px",
  bottom: "10px",
}



const Feedback = () => {
  const [feedbackData, setFeedbackData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewFeedback, setShowNewFeedback] = useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [questionIdList, setQuestionIdList] = useState([]);
  const [singleComment, setSingleComment] = useState()
  const [selectedQuestionEditable, setSelectedQuestionEditable] = useState(null); // Define selectedQuestionEditable
  const [QBCount, setQBCount] = useState(0); // Define QBCount
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(-1);
  const [questionData, setQuestionData] = useState([]);
  const [studentEmail, setStudentEmail] = useState([])
  const [commentName, setCommentName] = useState();
  const [questionID, setQuestionID] = useState();
  const [open, setOpen] = useState(false);
  const [openReply, setOpenReply] = useState(false);
  const editor = useRef(null);
  const [content, setContent] = useState('');
  const [contentError, setContentError] = useState(false)
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [selectedFeedback, setSelectedFeedback] = useState({});
  const gridApiRef = useRef(null);
  // Mirrors the applied page size so onGridReady can restore it after the grid is remounted
  // (switching between new/completed feedback unmounts the grid while loading).
  const effectivePageSizeRef = useRef(DEFAULT_PAGE_SIZE);
  //const [subject, setSubject] = useState()
  const handleOpen = (data) => {

    setSingleComment(data.value)
    setStudentEmail(data.data.studentEmail)
    setCommentName(data.data.name)
    setOpen(true)
  };
  const handleClose = () => {
    setOpen(false)
  };
  const handleCloseReply = () => {
    setOpenReply(false)
  }

  const getPlainText = (content) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = content;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  const onSendMailClick = () => {
    const body = {
      htmlBody: content,
      studentEmail: studentEmail,
      subject: 'Resolution of Your Feedback on QID: ' + questionID,
      textBody: getPlainText(content)
    }
    postData(apiPaths.sendQuestionFeedbackMail, {
      data: body,
    }).then((res) => {
      const responseData = res?.result;
      setRowData(responseData);
      Toaster(toast.TYPE.SUCCESS, `${res.msg}`);
      setLoading(false);
      handleCloseReply();
    });
  }



  const fetchData = useCallback(async (showLoading = true) => {
    if (showLoading) {
      setLoading(true)
    }
    try {
      const userDetails = getUserDetails();
      const statusQueryParam = showNewFeedback ? "COMPLETE" : "NEW";
      const queryParams = `?libTypeList=QBANK&libTypeList=TEST&status=${statusQueryParam}&tenantId=${userDetails.tenantId}&userEmail=${userDetails.email}`;
      const response = await getData(
        apiPaths.getFeedbackForQuestions + queryParams
      );
      const scopedFeedback = filterBySubjectScope(
        response.result || [],
        (f) => f.subjectId ?? f.subject_id
      );
      setFeedbackData(scopedFeedback);

      // Extract unique question IDs from feedback data
      const uniqueQuestionIds = [...new Set(scopedFeedback.map(feedback => feedback.questionId))];

      setQuestionIdList(uniqueQuestionIds);
      setQBCount(uniqueQuestionIds.length);

    } catch (error) {
      console.error("Error fetching feedback:", error);
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  }, [showNewFeedback]);

  useEffect(() => {
    fetchData();
  }, [fetchData, showNewFeedback]);

  const handleTickButtonClick = async (uniqueId, libType) => {
    try {
      const queryParams = new URLSearchParams({
        uniqueId,
        libType,
        newStatus: "COMPLETE", // Assuming you always want to set status as "COMPLETE"
      }).toString();

      const response = await postData(apiPaths.updateQuestionFeedbackStatus + "?" + queryParams, {
      });
      console.log("Feedback status updated:", response);
      // After updating the status, fetch the updated feedback data
      await fetchData(false);
    } catch (error) {
      console.error("Error updating feedback status:", error);
    }
  };

  const tickButtonRenderer = (params) => {
    const feedback = params.data;
    if (feedback.status === "NEW") {
      return (
        <div style={{ display: 'flex' }}>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => handleTickButtonClick(feedback.uniqueId, feedback.libType)}
          >
            <CheckCircleOutline /> {/* Use the CheckIcon component */}
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => onReplyClick(params.data)}
          >
            <EmailOutlined /> {/* Use the CheckIcon component */}
          </div>
        </div>
      );
    }
    return null;
  };

  const handleQuestionClick = (questionId) => {
    const clickedIndex = questionIdList.indexOf(questionId);

    setSelectedQuestionIndex(clickedIndex);
    setSelectedQuestionId(questionId);

    // Fetch question data for the clicked question ID
    getData(apiPaths.questionbyid + `?id=${questionId}`).then((response) => {
      if (response.result) {
        setQuestionData(response.result);
      }
    });
  };



  const columnDefs = [
    { headerName: "Name", field: "name", tooltipField: "name", filter: true },
    { headerName: "Library Type", field: "libType", tooltipField: "libType", filter: true },
    {
      headerName: "Question ID",
      field: "questionId",
      tooltipField: "questionId",
      filter: true,
      cellRendererFramework: (params) => (
        <div
          className="text-link"
          onClick={() => handleQuestionClick(params.value)}
          style={{ cursor: "pointer" }}
        >
          {params.value}
        </div>
      ),
    },
    // The Action cell only renders for NEW rows, so the whole column is dropped in the
    // Completed view rather than sitting blank next to Question ID.
    ...(showNewFeedback
      ? []
      : [
          {
            headerName: "Action",
            sortable: false,
            width: 110,
            minWidth: 110,
            suppressSizeToFit: true,
            cellRendererFramework: tickButtonRenderer,
          },
        ]),
    // {
    //   headerName: "Question",
    //   field: "questionPlainText",
    //   width: 200,
    //   filter: true,
    //   tooltipField: "questionPlainText",
    // },
    {
      headerName: "Student Email",
      field: "studentEmail",
      tooltipField: "studentEmail",
      filter: true,
    },
    {
      headerName: "Error Reported",
      field: "errorReported",
      tooltipField: "errorReported",
      filter: true,
    },
    {
      headerName: "Comments",
      field: "comments",
      tooltipField: "comments",
      filter: true,
      cellRendererFramework: (params) => (
        <Button onClick={() => { handleOpen(params) }}
          style={{ cursor: "pointer" }}>
          View
        </Button>

      ),
    },
    {
      headerName: "Created Date",
      field: "createdDate",
      filter: true,
      // The API sends epoch millis. Keep the raw value on the row (so sorting stays
      // chronological) and format only what the user sees, types against and hovers.
      valueFormatter: (params) => formatDateTime(params.value),
      filterValueGetter: (params) => formatDateTime(params.data && params.data.createdDate),
      tooltipValueGetter: (params) => formatDateTime(params.value),
    },
    { headerName: "Status", field: "status", tooltipField: "status", filter: true },
  ];

  const gridOptions = {
    columnDefs,
    rowData: feedbackData,
  };

  const handleToggleSwitch = () => {
    setShowNewFeedback(!showNewFeedback);
    setSelectedQuestionId(null);
    setSelectedQuestionIndex(-1);
    setQuestionData({});
  };

  const onReplyClick = (data) => {
    setSelectedFeedback(data);
    setStudentEmail(data.studentEmail);
    setCommentName(data.name);
    setQuestionID(data.questionId);
    setContent(`<p>Dear ${data.studentEmail},</p>
<p>Thank you for reaching out to us regarding your concern about the question in the Arise Medical Academy app. We appreciate your feedback, as it helps us improve the quality of our content.</p>
<p>Upon reviewing the question , we have <span style="background-color: rgb(255, 255, 0);">[corrected and verified]</span> the information accordingly. Kindly review the question for the updated Version.</p>
<p>We apologize for any confusion this may have caused and appreciate your patience. Please feel free to reach out if you have any further concerns or need additional clarification.</p>
<p>Thank you for being a valued user of Arise Medical Academy.</p>`)
    setOpenReply(true);
  }

  const rowCount = feedbackData.length;
  // "All" is a sentinel: ag-grid needs a real page size >= 1, so it resolves to the row count.
  const effectivePageSize = pageSize === ALL_PAGE_SIZE ? rowCount || 1 : pageSize;
  const showPager = rowCount > effectivePageSize;
  const showGrid = !loading && rowCount > 0;
  const showPageSizeSelector = showGrid && rowCount > SMALLEST_PAGE_SIZE;

  const onGridReady = useCallback((params) => {
    gridApiRef.current = params.api;
    // The grid is always built with DEFAULT_PAGE_SIZE, so re-apply the current selection whenever
    // the grid is (re)created - e.g. after toggling between new and completed feedback.
    if (params.api.paginationGetPageSize() !== effectivePageSizeRef.current) {
      params.api.paginationSetPageSize(effectivePageSizeRef.current);
    }
  }, []);

  useEffect(() => {
    effectivePageSizeRef.current = effectivePageSize;
    if (!showGrid) {
      gridApiRef.current = null; // the grid is unmounted; drop the stale api
      return;
    }
    const api = gridApiRef.current;
    if (api && api.paginationGetPageSize() !== effectivePageSize) {
      api.paginationSetPageSize(effectivePageSize);
    }
  }, [effectivePageSize, showGrid]);

  return (
    <>
      <div>
        <div
          className="toggle-button-container"
          style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 16, padding: "8px 0" }}
        >
          {!loading && (
            <Typography variant="body2" style={{ color: "#666" }}>
              {rowCount} {rowCount === 1 ? "feedback item" : "feedback items"}
            </Typography>
          )}
          {checkPermission('Students Feedback', 'Show Completed Feedback') && (
            <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
              <Typography>
                {showNewFeedback ? "Show Actioned Feedback" : "Show Completed Feedback"}
              </Typography>
              <Switch
                checked={showNewFeedback}
                onChange={handleToggleSwitch}
                size="small"
              />
            </div>
          )}
        </div>
        {loading && <p>Loading...</p>}
        {showGrid && <Grid
          gridOptions={{
            ...gridOptions,
            defaultColDef: DEFAULT_COL_DEF,
            pagination: true,
            paginationPageSize: DEFAULT_PAGE_SIZE,
            onGridReady,
          }}
          parent={"feedback" + (showPager ? "" : " ag-grid-hide-pager")}
        />}
        {showPageSizeSelector && (
          // `.ag-grid-main` is float:left, so a flex row after it is laid out beside the grid
          // instead of under it - it has to clear the float to sit below the pager.
          <div style={{ clear: "both", width: "100%", display: "flex", alignItems: "center", gap: 8, padding: "10px 0" }}>
            <Typography variant="body2" style={{ color: "#666" }}>Rows per page:</Typography>
            <Select
              variant="standard"
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              style={{ minWidth: 70 }}
            >
              {PAGE_SIZE_OPTIONS.map((size) => (
                <MenuItem key={size} value={size}>
                  {size}
                </MenuItem>
              ))}
              <MenuItem value={ALL_PAGE_SIZE}>All</MenuItem>
            </Select>
          </div>
        )}

        {selectedQuestionId && selectedQuestionIndex !== -1 && (
          <QuestionViewModal
            open={true}
            handleClose={() => {
              setSelectedQuestionId(null);
              setSelectedQuestionIndex(-1);
              setQuestionData({});
            }}
            selectedQuestionEditable={selectedQuestionEditable}
            isEditEnabled={true}
            prevQuestion={
              selectedQuestionIndex > 0
                ? questionIdList[selectedQuestionIndex - 1]
                : null
            }
            nxtQuestion={
              selectedQuestionIndex < questionIdList.length - 1
                ? questionIdList[selectedQuestionIndex + 1]
                : null
            }
            questionData={questionData}
            QBCount={QBCount}
            selectedQuestion={selectedQuestionId}
            // A reported question is often exactly the one that should go. Refetching also drops
            // the feedback rows whose question no longer resolves.
            onQuestionDeleted={() => {
              setSelectedQuestionId(null);
              setSelectedQuestionIndex(-1);
              setQuestionData({});
              fetchData();
            }}
            setId={(e) => {
              setSelectedQuestionId(e);
              setSelectedQuestionIndex(questionIdList.indexOf(e));
              // Fetch question data for the clicked question ID
              getData(apiPaths.questionbyid + `?id=${e}`).then((response) => {
                if (response.result) {
                  setQuestionData(response.result);
                }
              });
            }}
          />
        )}
      </div>

      <Dialog
        open={open}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        maxWidth="sm"
      >
        <DialogTitle style={{ borderBottom: "1px solid gainsboro" }}>Comment Details</DialogTitle>
        <DialogContent>
          <Box sx={style}>
            <CloseIcon sx={icon} onClick={handleClose} />
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Typography><span style={{ fontWeight: "bold" }}>Email:</span> <span style={{ color: "#3366FF", fontWeight: "bold" }}>{studentEmail}</span></Typography>
              <Typography><span style={{ fontWeight: "bold" }}>Name:</span> {commentName}</Typography>
              <Typography><span style={{ fontWeight: "bold" }}>Comment:</span> {singleComment ? singleComment : "No Comments"}</Typography>
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        fullWidth={true}
        open={openReply}
        onClose={handleCloseReply}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        maxWidth="lg"
        sx={{ minHeight: "420px !important" }}
        // Jodit renders its image/video/link popups into document.body, outside
        // this dialog. MUI's FocusTrap would pull focus back into the modal root
        // on focusin, leaving those popups' URL inputs impossible to type into.
        disableEnforceFocus
      >
        <DialogTitle style={{ border: "1px solid #e7e0e0", backgroundColor: "#e7e0e0" }}>Reply Message</DialogTitle>
        <DialogContent>
          <Box sx={style1}>
            <CloseIcon sx={icon} onClick={handleCloseReply} />
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Typography sx={{ borderBottom: "1px solid #e7e0e0", padding: "10px 10px 10px 0px" }}><span style={{ fontWeight: "bold" }}>To: </span><span style={{ color: "#3366FF" }}>{studentEmail}</span></Typography>
              <Typography sx={{ borderBottom: "1px solid #e7e0e0", padding: "10px 10px 10px 0px" }}><span style={{ fontWeight: "bold" }}>Subject: </span><span>Resolution of Your Feedback on QID: <span style={{ color: "#3366FF" }}>{questionID}</span></span></Typography>
            </Typography>

            {/* <Typography variant="h6"></Typography>
            <TextFields
              fullWidth
              multiline
              disabled
              value={singleComment}
              variant="outlined"
              sx={{ mb: 2 }}
            /> */}
            <JoditEditor
              ref={editor}
              value={content}
              tabIndex={1} // tabIndex of textarea
              onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
              onChange={(newContent) => { setContentError(false); setContent(newContent) }}
            />
            <div style={{ display: "flex", justifyContent: "right" }}>
              <button className="btn-common" style={{ marginTop: "10px", maxWidth: "120px" }} onClick={onSendMailClick}>Send</button>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Feedback;
